import type { M3ColorTokens, M3ThemeTones } from "./M3Theme";

// https://m3.material.io/theme-builder#/custom
// core primary: `#ef9a9a`

export const lightColorTokens: M3ColorTokens = {
  primary: "#9c4044",
  onPrimary: "#ffffff",
  primaryContainer: "#ffd9d9",
  onPrimaryContainer: "#400007",
  secondary: "#775656",
  onSecondary: "#ffffff",
  secondaryContainer: "#ffdad9",
  onSecondaryContainer: "#2c1515",
  tertiary: "#755a2f",
  onTertiary: "#ffffff",
  tertiaryContainer: "#ffddaa",
  onTertiaryContainer: "#281800",
  error: "#ba1b1b",
  onError: "#ffffff",
  errorContainer: "#ffdad4",
  onErrorContainer: "#410001",
  background: "#fcfcfc",
  onBackground: "#211a1a",
  surface: "#fcfcfc",
  onSurface: "#211a1a",
  surfaceVariant: "#f4dddc",
  onSurfaceVariant: "#534343",
  outline: "#857372",
  shadow: "#000000",
  inverseSurface: "#362f2f",
  inverseOnSurface: "#fbeeed",
  inversePrimary: "#ffb3b3",
};

export const darkColorTokens: M3ColorTokens = {
  primary: "#ffb3b3",
  onPrimary: "#5f131a",
  primaryContainer: "#7e2a2f",
  onPrimaryContainer: "#ffd9d9",
  secondary: "#e7bdbc",
  onSecondary: "#442929",
  secondaryContainer: "#5d3f3f",
  onSecondaryContainer: "#ffdad9",
  tertiary: "#e4c18d",
  onTertiary: "#422c05",
  tertiaryContainer: "#5b431a",
  onTertiaryContainer: "#ffddaa",
  error: "#ffb4a9",
  onError: "#680003",
  errorContainer: "#930006",
  onErrorContainer: "#ffb4a9",
  background: "#211a1a",
  onBackground: "#ede0df",
  surface: "#211a1a",
  onSurface: "#ede0df",
  surfaceVariant: "#534343",
  onSurfaceVariant: "#d8c2c1",
  outline: "#9f8c8b",
  shadow: "#000000",
  inverseSurface: "#ede0df",
  inverseOnSurface: "#362f2f",
  inversePrimary: "#9c4044",
};

export const tones: M3ThemeTones = {
  primary: {
    "0": "#000000",
    "10": "#400007",
    "20": "#5f131a",
    "30": "#7e2a2f",
    "40": "#9c4044",
    "50": "#bb585b",
    "60": "#da7173",
    "70": "#fb8a8c",
    "80": "#ffb3b3",
    "90": "#ffd9d9",
    "95": "#ffeceb",
    "99": "#fcfcfc",
    "100": "#ffffff",
  },
  secondary: {
    "0": "#000000",
    "10": "#2c1515",
    "20": "#442929",
    "30": "#5d3f3f",
    "40": "#775656",
    "50": "#916f6e",
    "60": "#ad8887",
    "70": "#c9a2a1",
    "80": "#e7bdbc",
    "90": "#ffdad9",
    "95": "#ffeceb",
    "99": "#fcfcfc",
    "100": "#ffffff",
  },
  tertiary: {
    "0": "#000000",
    "10": "#281800",
    "20": "#422c05",
    "30": "#5b431a",
    "40": "#755a2f",
    "50": "#8f7244",
    "60": "#ab8c5c",
    "70": "#c7a674",
    "80": "#e4c18d",
    "90": "#ffddaa",
    "95": "#ffeed6",
    "99": "#fcfcfc",
    "100": "#ffffff",
  },
  neutral: {
    "0": "#000000",
    "10": "#211a1a",
    "20": "#362f2f",
    "30": "#4d4545",
    "40": "#655c5c",
    "50": "#7f7574",
    "60": "#998e8e",
    "70": "#b4a9a8",
    "80": "#d0c4c3",
    "90": "#ede0df",
    "95": "#fbeeed",
    "99": "#fcfcfc",
    "100": "#ffffff",
  },
  neutralVariant: {
    "0": "#000000",
    "10": "#251818",
    "20": "#3b2d2d",
    "30": "#534343",
    "40": "#6b5a5a",
    "50": "#857372",
    "60": "#9f8c8b",
    "70": "#bba6a5",
    "80": "#d8c2c1",
    "90": "#f4dddc",
    "95": "#ffeceb",
    "99": "#fcfcfc",
    "100": "#ffffff",
  },
  error: {
    "0": "#000000",
    "10": "#410001",
    "20": "#680003",
    "30": "#930006",
    "40": "#ba1b1b",
    "50": "#dd3730",
    "60": "#ff5449",
    "70": "#ff897a",
    "80": "#ffb4a9",
    "90": "#ffdad4",
    "95": "#ffede9",
    "99": "#fcfcfc",
    "100": "#ffffff",
  },
};
